// @ts-nocheck
import React from 'react';
import CommonForm from '../../../components/hoc/common/handbook/CommonForm';
import Grid, { GridItem } from '../../../components/layout/Grid';
import { FormField } from '../../../components/Form';
import VehicleModelSelect from '../../../components/selects/VehicleModelSelect';
import VehicleIssueGroupSelect from '../../../components/selects/VehicleIssueGroupSelect';
import { Section, SectionTitle } from '../../../components/layout';
import { SectionContent, StyledInput, StyledInputNumber } from '../../../components/hoc/common/components/elements';
import { Selects } from '../../../components';
import { ListTable } from '../../../components/ui';
import { withEmptyRow } from '../../../lib/helpers';
const {
  MdmSelect,
  MaintenanceOperationSelect
} = Selects;
export default props => {
  return <CommonForm {...props}>
      {({
      setFieldValue,
      values
    }) => {
      return <>
            <Section noWrapMe>
              <SectionContent>
                <Grid gutter="16px">
                  <GridItem>
                    <FormField required fast label="Модель ТС" name="vehicleModelId">
                      {({
                    value,
                    name
                  }) => <VehicleModelSelect value={value} name={name} onChange={async value => setFieldValue(name, value)} />}
                    </FormField>
                  </GridItem>
                  <GridItem>
                    <FormField required fast label="Вид работы по капитальному ремонту" name="vehicleIssueGroupId">
                      {({
                    value,
                    name
                  }) => <VehicleIssueGroupSelect value={value} name={name} onChange={async value => setFieldValue(name, value)} />}
                    </FormField>
                  </GridItem>
                </Grid>
              </SectionContent>
            </Section>
            <Section noWrapMe>
              <SectionTitle divider>Операции по ремонту</SectionTitle>
              <ListTable showHeader={false} columns={[{
            key: 'operationId',
            render: (id, data, index) => {
              return <MaintenanceOperationSelect value={id} onChange={value => setFieldValue(`operations[${index}].operationId`, value)} />;
            }
          }]} data={withEmptyRow(values.operations)} />
            </Section>
            <Section noWrapMe>
              <SectionTitle divider>
                Планируемый перечень запасных запчастей
              </SectionTitle>
              <SectionContent>
                <ListTable columns={[{
              title: 'Наименование материала',
              key: 'mnemocode',
              width: '33%',
              render: (id, data, index) => {
                return <MdmSelect value={id} hideMnemocode onChange={(data, option) => {
                  setFieldValue(`mtrs[${index}].mtrId`, option.props.mdm.id);
                  setFieldValue(`mtrs[${index}].mnemocode`, option.props.mdm.mnemocode);
                }} />;
              }
            }, {
              title: 'Мнемокод',
              key: 'mnemocode',
              render: id => {
                return <StyledInput disabled value={id} />;
              }
            }, {
              title: 'Кол-во',
              key: 'count',
              render: (count, data, index) => {
                return <StyledInputNumber value={count} onChange={value => setFieldValue(`mtrs[${index}].count`, value)} />;
              }
            }]} data={withEmptyRow(values.mtrs)} />
              </SectionContent>
            </Section>
          </>;
    }}
    </CommonForm>;
};
